import _ from "lodash";
import { observer } from "mobx-react";
import type React from "react";
import { useMemo } from "react";
import { ThemeProvider } from "styled-components/macro";

import { getThemeTextSize } from "a11y-utils";

import { useDomainHandler } from "hooks/useDomainHandler";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useProfile } from "hooks/useProfile";

import { hogesTheme } from "./hoges";
import { hogesBusinessTheme } from "./hogesBusiness";
import { hogesNoordhoffTheme } from "./noordhoff";

interface ComponentWithChildren {
  children: React.ReactNode;
}

export const ThemeContainer: React.FC<ComponentWithChildren> = observer(({ children }) => {
  const { isBusinessThemeActive, enableProductNoordhoffRedesign } = useFeatureFlags();
  const { isBusinessDomain } = useDomainHandler();
  const { userDetails } = useProfile();

  const currentTheme = useMemo(() => {
    const isBusinessTheme = isBusinessDomain() && isBusinessThemeActive;
    const baseTheme = enableProductNoordhoffRedesign
      ? hogesNoordhoffTheme
      : isBusinessTheme
        ? hogesBusinessTheme
        : hogesTheme;

    // Build final theme based on selected size
    return _.merge({}, baseTheme, getThemeTextSize(userDetails?.textSize));
  }, [
    isBusinessThemeActive,
    userDetails?.textSize,
    isBusinessDomain,
    enableProductNoordhoffRedesign,
  ]);

  return <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>;
});
